/** Notification retry config — defaults and bounds (must match ris-backend). */

export const DEFAULT_MAX_RETRY_COUNT = 3;
export const DEFAULT_RETRY_INTERVAL_MINUTES = 5;
export const MIN_MAX_RETRY_COUNT = 0;
export const MAX_MAX_RETRY_COUNT = 10;
export const MIN_RETRY_INTERVAL_MINUTES = 1;
export const MAX_RETRY_INTERVAL_MINUTES = 1440;
